// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/antdesignpro/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from 'D:/antdesignpro/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import TableOutlined from 'D:/antdesignpro/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
import LaptopOutlined from 'D:/antdesignpro/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/LaptopOutlined';
import SettingOutlined from 'D:/antdesignpro/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { SmileOutlined, CrownOutlined, TableOutlined, LaptopOutlined, SettingOutlined };
